import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadCommittee: ICommitteeLoadActionCreator = () => {
        return {
            type: ACTION_COMMITTEES_LOAD
        }
    },
    LoadCommitteeById: ICommitteeLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_COMMITTEES_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ICommitteeLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_COMMITTEES_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ICommitteeLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEES_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveCommittee: ICommitteeSaveActionCreator = (formData) => {
        return {
            type: ACTION_COMMITTEES_SAVE,
            formData
        }
    },
    SaveSuccess: ICommitteeSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_COMMITTEES_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ICommitteeSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEES_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateCommittee: ICommitteeCreateActionCreator = () => {

        return {
            type: ACTION_COMMITTEES_CREATE
        }
    },
    CreateSuccess: ICommitteeCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_COMMITTEES_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ICommitteeCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEES_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateCommittee: ICommitteeValidateActionCreator = (formData) => {
        return {
            type: ACTION_COMMITTEES_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ICommitteeValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_COMMITTEES_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ICommitteeValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEES_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ICommitteeClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_COMMITTEES_CLEAR,
            propertiesToClear
        }
    },

    Filter: ICommitteeFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_COMMITTEES_FILTER,
            formFilter
        }
    };



export const
    ACTION_COMMITTEES_LOAD = "ACTION_COMMITTEES_LOAD",
    ACTION_COMMITTEES_LOAD_BY_ID = "ACTION_COMMITTEES_LOAD_BY_ID",
    ACTION_COMMITTEES_LOAD_SUCCESS = "ACTION_COMMITTEES_LOAD_SUCCESS",
    ACTION_COMMITTEES_LOAD_FAILURE = "ACTION_COMMITTEES_LOAD_FAILURE",

    ACTION_COMMITTEES_SAVE = "ACTION_COMMITTEES_SAVE",
    ACTION_COMMITTEES_SAVE_SUCCESS = "ACTION_COMMITTEES_SAVE_SUCCESS",
    ACTION_COMMITTEES_SAVE_FAILURE = "ACTION_COMMITTEES_SAVE_FAILURE",

    ACTION_COMMITTEES_CREATE = "ACTION_COMMITTEES_CREATE",
    ACTION_COMMITTEES_CREATE_SUCCESS = "ACTION_COMMITTEES_CREATE_SUCCESS",
    ACTION_COMMITTEES_CREATE_FAILURE = "ACTION_COMMITTEES_CREATE_FAILURE",

    ACTION_COMMITTEES_VALIDATE = "ACTION_COMMITTEES_VALIDATE",
    ACTION_COMMITTEES_VALIDATE_SUCCESS = "ACTION_COMMITTEES_VALIDATE_SUCCESS",
    ACTION_COMMITTEES_VALIDATE_FAILURE = "ACTION_COMMITTEES_VALIDATE_FAILURE",

    ACTION_COMMITTEES_CLEAR = "ACTION_COMMITTEES_CLEAR",

    ACTION_COMMITTEES_FILTER = "ACTION_COMMITTEES_FILTER";

export interface ICommitteeLoadAction {
    type: "ACTION_COMMITTEES_LOAD";
}

export interface ICommitteeLoadActionCreator {
    (): ICommitteeLoadAction;
}

export interface ICommitteeLoadSuccessAction {
    type: "ACTION_COMMITTEES_LOAD_SUCCESS";
    formData: Dtos.Committee | Dtos.Committee[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeLoadSuccessActionCreator {
    (
        formData: Dtos.Committee | Dtos.Committee[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeLoadSuccessAction;
}

export interface ICommitteeLoadFailureAction {
    type: "ACTION_COMMITTEES_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeLoadFailureAction;
}

export interface ICommitteeLoadByIdAction {
    type: "ACTION_COMMITTEES_LOAD_BY_ID";
    id: number;
}

export interface ICommitteeLoadByIdActionCreator {
    (id: number): ICommitteeLoadByIdAction;
}


export interface ICommitteeSaveAction {
    type: "ACTION_COMMITTEES_SAVE";
    formData: Dtos.Committee;

}

export interface ICommitteeSaveActionCreator {
    (
        formData: Dtos.Committee,
    ): ICommitteeSaveAction;
}

export interface ICommitteeSaveSuccessAction {
    type: "ACTION_COMMITTEES_SAVE_SUCCESS";
    formData: Dtos.Committee;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeSaveSuccessActionCreator {
    (
        formData: Dtos.Committee,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeSaveSuccessAction;
}

export interface ICommitteeSaveFailureAction {
    type: "ACTION_COMMITTEES_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeSaveFailureAction;
}

export interface ICommitteeCreateAction {
    type: "ACTION_COMMITTEES_CREATE"
}

export interface ICommitteeCreateActionCreator {
    (): ICommitteeCreateAction
}

export interface ICommitteeCreateSuccessAction {
    type: "ACTION_COMMITTEES_CREATE_SUCCESS";
    formData: Dtos.Committee;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface ICommitteeCreateSuccessActionCreator {
    (
        formData: Dtos.Committee,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ICommitteeCreateSuccessAction;
}

export interface ICommitteeCreateFailureAction {
    type: "ACTION_COMMITTEES_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeCreateFailureAction;
}

export interface ICommitteeValidateAction {
    type: "ACTION_COMMITTEES_VALIDATE";
    formData: Dtos.Committee;

}

export interface ICommitteeValidateActionCreator {
    (
        formData: Dtos.Committee,
    ): ICommitteeValidateAction;
}

export interface ICommitteeValidateSuccessAction {
    type: "ACTION_COMMITTEES_VALIDATE_SUCCESS";
    formData: Dtos.Committee;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeValidateSuccessActionCreator {
    (
        formData: Dtos.Committee,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeValidateSuccessAction;
}

export interface ICommitteeValidateFailureAction {
    type: "ACTION_COMMITTEES_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeValidateFailureAction;
}

export interface ICommitteeClearAction {
    type: "ACTION_COMMITTEES_CLEAR";
    propertiesToClear?: string[];
}

export interface ICommitteeClearActionCreator {
    (propertiesToClear?: string[]): ICommitteeClearAction;
}

export interface ICommitteeFilterActionCreator {
    (formFilter: IFormFilter): ICommitteeFilterAction;
}

export interface ICommitteeFilterAction {
    type: "ACTION_COMMITTEES_FILTER";
    formFilter: IFormFilter;
}

export type CommitteeAction =
    ICommitteeLoadAction |
    ICommitteeLoadByIdAction |
    ICommitteeLoadFailureAction |
    ICommitteeLoadSuccessAction |
    ICommitteeSaveAction |
    ICommitteeSaveSuccessAction |
    ICommitteeSaveFailureAction |
    ICommitteeCreateAction |
    ICommitteeCreateSuccessAction |
    ICommitteeCreateFailureAction |
    ICommitteeValidateAction |
    ICommitteeValidateSuccessAction |
    ICommitteeValidateFailureAction |
    ICommitteeFilterAction | 
    ICommitteeClearAction;
